import { Alert, Announcement } from '@servicetitan/anvil2';
import classNames from 'classnames';
import { FC } from 'react';
import { BannerColorStatus, BannerStyleStatus } from '../utils/banner-settings';
import { sanitizeBannerHtml } from '../utils/sanitize-banner-html';
import * as Styles from './banner-message.module.less';

const COLOR_TO_STATUS: Record<BannerColorStatus, 'info' | 'success' | 'warning' | 'danger'> = {
    [BannerColorStatus.Info]: 'info',
    [BannerColorStatus.Success]: 'success',
    [BannerColorStatus.Warning]: 'warning',
    [BannerColorStatus.Danger]: 'danger',
};

export interface BannerMessageProps {
    color: BannerColorStatus;
    messageHtml: string;
    onClose?: () => void;
    style: BannerStyleStatus;
}

/*
 * Keep in sync with
 * Clients/mfe/packages/tenant-settings/src/components/feature-control-section/custom-banner-card/banner-message.tsx
 */
export const BannerMessage: FC<BannerMessageProps> = ({ color, messageHtml, onClose, style }) => {
    const status = COLOR_TO_STATUS[color] ?? 'info';
    const sanitized = sanitizeBannerHtml(messageHtml);
    /* eslint-disable react/no-danger, @typescript-eslint/naming-convention */
    const message = <div dangerouslySetInnerHTML={{ __html: sanitized }} />;
    /* eslint-enable react/no-danger, @typescript-eslint/naming-convention */

    /*
     * Alert only takes a plain-string title, so the rich-text message has to go in its content
     * slot, which Anvil stacks below the icon row. inlineAlert flattens that back onto one line.
     */
    if (style === BannerStyleStatus.Alert) {
        return (
            <Alert
                className={classNames(Styles.bannerMessage, Styles.inlineAlert)}
                status={status}
                title=""
                onClose={onClose}
            >
                {message}
            </Alert>
        );
    }

    return (
        <Announcement
            className={classNames(Styles.bannerMessage, Styles.wrappingAnnouncement)}
            status={status}
            title=""
            onClose={onClose}
        >
            {message}
        </Announcement>
    );
};
